import { ref, watch } from "vue";

export const resetConfigurator = ref(false);

watch(
  resetConfigurator,
  (val) => {
    console.log(val);
  },
  {
    immediate: true,
  }
);
